module.exports = __webpack_public_path__ + "img/palladiumWhitegold@2x.cb69bf4.webp";